// True when the page was served as prerendered HTML (react-snap). Set in main.tsx
// before React mounts. Used to skip above-the-fold entrance animations so the
// client render doesn't flash content that is already visible.
export const wasPrerendered = (): boolean =>
  typeof window !== "undefined" && (window as any).__ENVIR_PRERENDERED__ === true;

// Lazy Supabase client: keeps the SDK (~100 KB) out of the main bundle.
export const getSupabase = () =>
  import("@/integrations/supabase/client").then((m) => m.supabase);
